import React from "react";
import isEqual from "lodash-es/isEqual";
import {sendRequest} from "../../../utils/request";
import Module from "./Module";
import {SortableContainer, SortableElement, SortableHandle} from "react-sortable-hoc";
import AttributeEditor from "./AttributeEditor";
import classNames from "classnames";

const SortableModuleHandle = SortableHandle((props) => <span className="drag"/>);
const SortableModule = SortableElement((props) => <Module drag={!props.disabled && <SortableModuleHandle />} {...props} />);
const SortableList = SortableContainer((props) => <div {...props}>
    {React.Children.toArray(props.children).map((Child, index) => <Child.type {...Child.props} index={index} collection={0} />)}
</div>);

export default class Modules extends React.Component {

    state = {
        modules: [],
        isLoading: true,
        id: new Date().getTime(),
        dragging: false
    }

    componentDidMount() {
        this.calculateModules();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (!isEqual(this.props.parts, prevProps.parts)) {
            if (!((Array.isArray(this.props.parts) && this.props.parts.length) && (Array.isArray(prevProps.parts) && prevProps.parts.length) && isEqual(this.props.parts.map((part) => part.id), prevProps.parts.map((part) => part.id)))) {
                this.calculateModules();
            }
        }
    }

    calculateModules = () => {
        this.setState({isLoading: true}, () => {
            this.modules && this.modules.abort();
            if ((Array.isArray(this.props.parts) && this.props.parts.length) || this.props.parts === undefined) {
                this.modules = sendRequest({
                    option: "componentlist",
                    component: "MjmlPart",
                    itemsperpage: 0
                });
                this.modules.then((response) => {
                    this.setState({
                        isLoading: false,
                        modules: response.items
                    });
                });
            } else {
                this.setState({
                    isLoading: false,
                    modules: []
                });
            }
        });
    }

    onSortStart = () => {

    }

    updateBeforeSortStart = () => {
        this.setState({dragging: true});
    }

    onSortEnd = (e) => {
        this.props.onSortEnd(e);
        this.setState({dragging: false});
    }

    render() {
        if (this.state.isLoading) return <div className={this.props.className}/>;
        if (this.props.parts !== undefined) {
            if (!this.state.modules.length) return null;
            if (this.props.disabled) {
                return <div className={this.props.className}>
                    {Object.keys(this.props.attributes).map((attributeName, index) => <AttributeEditor key={index} disabled={this.props.disabled} attributeName={attributeName} attribute={this.props.attributes[attributeName]} />)}
                    {this.props.parts.map((part, index) => <Module key={index} disabled={this.props.disabled} module={this.state.modules.find((module) => module.id + "" === "" + part.id)} />)}
                </div>
            } else {
                return <div className={classNames(this.props.className, {sorting: this.state.dragging})}>
                    {Object.keys(this.props.attributes).map((attributeName, index) => <AttributeEditor key={index} disabled={this.props.disabled} attributeName={attributeName} attribute={this.props.attributes[attributeName]} onAttributeChanged={this.props.onAttributeChanged} />)}
                    <SortableList
                        id={this.state.id}
                        helperContainer={() => document.getElementById(this.state.id)}
                        axis="y"
                        helperClass="dragging"
                        updateBeforeSortStart={this.updateBeforeSortStart}
                        onSortStart={this.onSortStart}
                        onSortEnd={this.onSortEnd}
                        useDragHandle
                    >
                        {this.props.parts.map((part, index) => <SortableModule
                            part={part}
                            partIndex={index}
                            component={this.props.component}
                            componentId={this.props.componentId}
                            disabled={part.excluded || part.fixed}
                            excluded={part.excluded}
                            fixed={part.fixed}
                            head={part.head}
                            module={this.state.modules.find((module) => module.id + "" === "" + part.id)}
                            modules={this.state.modules}
                            onSelectSection={this.props.onSelectSection}
                            onFocusSection={() => this.props.onFocusSection(index)}
                            onPartInsert={(position, partId) => this.props.onPartInsert(index, position, partId)}
                            onPartPaste={() => this.props.onPartPaste(index)}
                            onVariableChanged={(variableName, variable) => this.props.onVariableChanged(index, variableName, variable)}
                            onVariablesChanged={(variables) => this.props.onVariablesChanged(index, variables)}
                            onPartRemove={() => {this.props.onPartRemove(index)}}
                        />)}
                    </SortableList>
                </div>;
            }
        } else {
            return (
                <div className={this.props.className}>
                    {this.state.modules.map((module) => {
                        return <Module module={module}/>
                    })}
                </div>
            );
        }
    }
}